import {
  setUserProperties,
  UserDataState,
} from "src/utils/redux/slices/userData";
import { ActionHandlerParams } from "..";

export const persistUserDataFeatureRolloutType = ({
  store,
}: ActionHandlerParams) => {
  const { userData, persistentBrowserFlags } = store.getState();

  const updatedFeatureRolloutTypes = {
    ...(userData?.featureRolloutTypes || {}),
    ...(persistentBrowserFlags?.featureRolloutTypes || {}),
  };

  store.dispatch(
    setUserProperties({
      featureRolloutTypes: updatedFeatureRolloutTypes,
    } as Partial<UserDataState>)
  );
};
